import {axiosCatchHandler} from "../sharedGlobal";
import axios from "axios";

const state = {};

const getters = {};

const actions = {
  fetchChangesCsv: async (context, websiteId = null) => {
    const endpointUrl = `/onsite-optimizer/export/csv/actions/${websiteId}`;
    const response = await axios.get(endpointUrl);
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');

    await window.mixpanel('Optimizer: Download CSV');

    link.href = url;
    link.setAttribute('download', response.headers['content-disposition'].split('filename=')[1]);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  fetchCompletedActionsTime: async (context, websiteId = null) => {
    const url = `/onsite-optimizer/actions/completed-time/${websiteId}`;
    const { data } = await axios.get(url);

    return data?.totalActionsTime ?? 0;
  },
  downgradeWebsite: async ({commit, dispatch }, websiteId) => {
    try {
      const { data } = await axios.get(`/onsite-optimizer/website/${websiteId}/pause`);
      window.location.href = data.redirectUrl;
    } catch (error) {
      axiosCatchHandler(error, () => {});

      if (error.response.status === 402) {
        const { paymentIntent } = error.response.data;

        window.stripeInstance.confirmCardPayment(paymentIntent.clientSecret, {
          payment_method: paymentIntent.paymentMethod,
        }).then((result) => {
          if (result.error) {
            axios.get('/stripe/payment-verification-failed');

            Swal.fire({
              icon: 'warning',
              title: 'Downgrade failed',
              html: 'We were unable to verify your payment for this website,<br>please try again later.',
            });

            return;
          }

          dispatch('downgradeWebsite', websiteId);
        })

        return;
      }

      Swal.fire({
        icon: 'warning',
        title: 'Downgrade failed',
        html: 'Sorry, there was a problem downgrading your website.',
      });
    }
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
